(function () {
'use strict';
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
const store = {
get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
};
function formatMoney(cents) {
const fmt = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
const value = (cents / 100);
const withDelims = (n, dec, th, ds) => {
const parts = n.toFixed(dec).split('.');
parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
return parts.join(ds);
};
return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
switch (key) {
case 'amount': return withDelims(value, 2, ',', '.');
case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
default: return withDelims(value, 2, '.', ',');
}
});
}
let toastTimer;
function toast(msg) {
const el = $('[data-toast]');
if (!el) return;
el.textContent = msg;
el.classList.add('is-visible');
clearTimeout(toastTimer);
toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
}
let lastFocus = null;
function openDrawer(id) {
const d = document.getElementById(id);
if (!d) return;
$$('[data-drawer].is-open').forEach(o => { if (o !== d) closeDrawer(o, true); });
lastFocus = document.activeElement;
d.classList.add('is-open');
d.setAttribute('aria-hidden', 'false');
document.body.classList.add('is-locked');
const panel = d.querySelector('.drawer__panel');
const focusTarget = d.querySelector('input[type="search"]') || panel;
if (panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 60);
}
function closeDrawer(d, keepLock) {
d.classList.remove('is-open');
d.setAttribute('aria-hidden', 'true');
if (!keepLock && !$('[data-drawer].is-open') && !$('.modal.is-open')) document.body.classList.remove('is-locked');
if (!keepLock && lastFocus) lastFocus.focus({ preventScroll: true });
}
document.addEventListener('click', (e) => {
const opener = e.target.closest('[data-drawer-open]');
if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
const closer = e.target.closest('[data-drawer-close]');
if (closer) { const d = closer.closest('[data-drawer]'); if (d) closeDrawer(d); }
});
document.addEventListener('keydown', (e) => {
if (e.key !== 'Escape') return;
$$('[data-drawer].is-open').forEach(d => closeDrawer(d));
$$('.modal.is-open').forEach(m => closeModal(m));
});
function initHeader() {
const header = $('[data-header]');
if (!header) return;
const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
setH();
window.addEventListener('resize', setH);
const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });
const active = $('.catbar__link.is-active');
if (active) active.scrollIntoView({ block: 'nearest', inline: 'center' });
}
function initRotators(root = document) {
$$('[data-rotator]', root).forEach(r => {
if (r.dataset.ready) return; r.dataset.ready = '1';
const items = $$('[data-rotator-item]', r);
if (items.length < 2) return;
let i = 0, timer;
const show = (n) => {
items[i].classList.remove('is-active');
i = (n + items.length) % items.length;
items[i].classList.add('is-active');
};
const start = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), parseInt(r.dataset.interval, 10) || 5000); };
const prev = $('[data-rotator-prev]', r), next = $('[data-rotator-next]', r);
if (prev) prev.addEventListener('click', () => { show(i - 1); start(); });
if (next) next.addEventListener('click', () => { show(i + 1); start(); });
start();
});
}
function initSliders(root = document) {
$$('[data-slider]', root).forEach(slider => {
if (slider.dataset.ready) return; slider.dataset.ready = '1';
const track = $('[data-slider-track]', slider);
if (!track) return;
const slides = $$('[data-slide]', track);
if (!slides.length) return;
const center = slider.dataset.sliderMode === 'center';
const dots = $$('[data-slider-dots] .dot', slider);
const counter = $('[data-slider-current]', slider);
const prev = $('[data-slider-prev]', slider);
const next = $('[data-slider-next]', slider);
let index = 0;
const targetLeft = (s) => center
? s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2
: s.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0);
const current = () => {
let best = 0, bestDist = Infinity;
slides.forEach((s, n) => {
const d = Math.abs(targetLeft(s) - track.scrollLeft);
if (d < bestDist) { bestDist = d; best = n; }
});
return best;
};
const update = () => {
index = current();
dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
if (counter) counter.textContent = index + 1;
if (prev) prev.disabled = !center && track.scrollLeft <= 2;
if (next) next.disabled = !center && track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
slider.dispatchEvent(new CustomEvent('slider:change', { detail: { index } }));
};
const go = (n, smooth = true) => {
const i = Math.max(0, Math.min(slides.length - 1, n));
track.scrollTo({ left: targetLeft(slides[i]), behavior: smooth ? 'smooth' : 'auto' });
};
slider.goTo = go;
let raf;
track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(index - 1); });
if (next) next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(index + 1); });
const start = parseInt(slider.dataset.sliderStart || '0', 10);
if (start) requestAnimationFrame(() => { go(start, false); update(); });
else update();
window.addEventListener('resize', () => go(index, false));
});
}
function initReels(root = document) {
const reels = $$('[data-reel]', root);
if (!reels.length) return;
const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
entries.forEach(en => {
const v = $('video', en.target);
if (!v) return;
if (en.isIntersecting && en.intersectionRatio > 0.6) { v.play().catch(() => {}); }
else { v.pause(); }
});
}, { threshold: [0, 0.6, 1] }) : null;
reels.forEach(r => {
const v = $('video', r);
if (!v) return;
v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
if (io) io.observe(r);
const btn = $('[data-reel-sound]', r);
if (btn) btn.addEventListener('click', () => {
const willUnmute = v.muted;
$$('[data-reel] video').forEach(o => { o.muted = true; o.closest('[data-reel]').classList.remove('is-unmuted'); });
v.muted = !willUnmute;
r.classList.toggle('is-unmuted', willUnmute);
btn.setAttribute('aria-label', willUnmute ? 'Disattiva audio' : 'Attiva audio');
if (willUnmute) v.play().catch(() => {});
});
});
}
const SECTION = 'cart-drawer';
function renderCart(sections) {
if (!sections || !sections[SECTION]) return;
const doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
const fresh = doc.getElementById('cart-drawer-inner');
const current = document.getElementById('cart-drawer-inner');
if (fresh && current) current.replaceWith(fresh);
const count = fresh ? parseInt(fresh.dataset.count, 10) : 0;
$$('[data-cart-count]').forEach(el => { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
}
async function addToCart(id, qty = 1) {
const res = await fetch(window.theme.routes.cartAdd + '.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: SECTION, sections_url: window.location.pathname })
});
const data = await res.json();
if (!res.ok || data.status) throw new Error(data.description || data.message || 'Errore');
renderCart(data.sections);
if (window.theme.cartType === 'page') { window.location.href = window.theme.routes.cart; return; }
openDrawer('cart-drawer');
}
async function changeLine(line, quantity) {
const inner = document.getElementById('cart-drawer-inner');
if (inner) inner.style.opacity = '.5';
try {
const res = await fetch(window.theme.routes.cartChange + '.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: SECTION, sections_url: window.location.pathname })
});
const data = await res.json();
if (data.status) toast(data.description || data.message);
renderCart(data.sections);
} finally {
const now = document.getElementById('cart-drawer-inner');
if (now) now.style.opacity = '';
}
}
document.addEventListener('click', async (e) => {
const quick = e.target.closest('[data-quick-add]');
if (quick) {
e.preventDefault();
quick.classList.add('is-loading');
try { await addToCart(quick.dataset.quickAdd); }
catch (err) { toast(err.message); }
finally { quick.classList.remove('is-loading'); }
return;
}
const lineBtn = e.target.closest('[data-line-change]');
if (lineBtn) { e.preventDefault(); changeLine(lineBtn.dataset.lineChange, lineBtn.dataset.qty); return; }
const cartOpen = e.target.closest('[data-cart-open]');
if (cartOpen && window.theme.cartType !== 'page' && document.getElementById('cart-drawer')) {
e.preventDefault(); openDrawer('cart-drawer');
}
});
async function openQuickView(url) {
const content = $('[data-qa-content]');
if (!content) { window.location.href = url; return; }
content.innerHTML = '<div class="qa-loading"><span></span></div>';
openDrawer('quick-add');
try {
const sep = url.includes('?') ? '&' : '?';
const html = await (await fetch(url + sep + 'section_id=quick-add')).text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const qa = doc.querySelector('[data-qa]') || doc.querySelector('.qa');
if (!qa) throw new Error('missing');
content.innerHTML = '';
content.appendChild(qa);
initProduct(content);
if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
} catch (e) { window.location.href = url; }
}
document.addEventListener('click', (e) => {
const qv = e.target.closest('[data-quick-view]');
if (qv) { e.preventDefault(); openQuickView(qv.dataset.quickView); return; }
const step = e.target.closest('[data-qty-step]');
if (step) {
const input = step.parentElement.querySelector('input');
input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
}
});
function initProduct(root = document) {
$$('[data-product]', root).forEach(section => {
if (section.dataset.ready) return; section.dataset.ready = '1';
const jsonEl = $('[data-product-json]', section);
if (!jsonEl) return;
const product = JSON.parse(jsonEl.textContent);
let inventory = {};
try { inventory = JSON.parse($('[data-inventory-json]', section).textContent); } catch (e) {}
const lowStock = parseInt(($('[data-low-stock]', section) || {}).textContent || '0', 10);
const picker = $('[data-variant-picker]', section);
const form = $('[data-product-form]', section);
const idInput = $('[data-variant-id]', section);
const addBtn = $('[data-add-btn]', section);
const addLabel = $('[data-add-label]', section);
const stockEl = $('[data-stock]', section);
const priceWrap = $('[data-price-wrap] [data-price]', section);
const gallery = $('.pdp__gallery', section);
const stickyPrice = $('[data-sticky-price]', section);
const selectedOptions = () => $$('fieldset[data-option-index]', picker || section)
.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
const findVariant = (opts) => product.variants.find(v => v.options.every((o, i) => o === opts[i]));
const markAvailability = (opts) => {
if (!picker) return;
$$('fieldset[data-option-index]', picker).forEach((fs, idx) => {
$$('.opt__btn', fs).forEach(label => {
const val = $('input', label).value;
const test = opts.slice(); test[idx] = val;
const v = product.variants.find(vv => vv.options.every((o, i) => i === idx ? o === val : (i < idx ? o === test[i] : true)));
const exact = findVariant(test);
const available = exact ? exact.available : !!(v && v.available);
label.classList.toggle('is-unavailable', !available);
});
});
};
const updateStock = (v) => {
if (!stockEl) return;
const q = v ? inventory[v.id] : null;
stockEl.textContent = (v && v.available && q !== null && q !== undefined && q > 0 && q <= lowStock)
? (q === 1 ? 'Ultimo pezzo disponibile' : `Solo ${q} pezzi disponibili`) : '';
};
const update = () => {
const opts = selectedOptions();
const v = findVariant(opts);
$$('fieldset[data-option-index]', picker || section).forEach((fs, i) => {
const out = $('[data-option-value]', fs); if (out) out.textContent = opts[i] || '';
});
markAvailability(opts);
if (!v) {
addBtn.disabled = true; addLabel.textContent = 'Non disponibile';
updateStock(null);
return;
}
idInput.value = v.id;
addBtn.disabled = !v.available;
addLabel.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
updateStock(v);
if (priceWrap) {
const sale = v.compare_at_price && v.compare_at_price > v.price;
priceWrap.classList.toggle('price--sale', !!sale);
priceWrap.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>` +
(sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__badge">-${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)}%</span>` : '');
}
if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
if (v.featured_media && gallery && gallery.goTo) {
const slides = $$('[data-slide]', gallery);
const idx = slides.findIndex(s => s.dataset.mediaId == v.featured_media.id);
if (idx > -1) {
if (window.matchMedia('(min-width: 990px)').matches) { /* desktop grid: no scroll jump */ }
else gallery.goTo(idx);
}
}
if (!section.hasAttribute('data-no-url')) {
const url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
}
};
if (picker) picker.addEventListener('change', update);
if (picker) { const opts = selectedOptions(); markAvailability(opts); updateStock(findVariant(opts)); }
else updateStock(product.variants[0]);
if (form) form.addEventListener('submit', async (e) => {
e.preventDefault();
if (addBtn.disabled) return;
const label = addLabel.textContent;
addBtn.disabled = true; addLabel.textContent = 'Aggiungo…';
const qtyInput = form.querySelector('[name="quantity"]');
try { await addToCart(idInput.value, qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1); }
catch (err) { toast(err.message); }
finally { addBtn.disabled = false; addLabel.textContent = label; }
});
const sticky = $('[data-sticky-atc]', section);
if (sticky && addBtn && 'IntersectionObserver' in window) {
new IntersectionObserver(([en]) => {
const show = !en.isIntersecting && en.boundingClientRect.top < 0;
sticky.classList.toggle('is-visible', show);
sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
}).observe(addBtn);
$('[data-sticky-btn]', sticky).addEventListener('click', () => {
if (!addBtn.disabled && (!picker || findVariant(selectedOptions()))) form.requestSubmit();
else addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
}
});
}
function initRecommendations(root = document) {
$$('[data-recommendations]', root).forEach(async el => {
if (el.dataset.ready || el.children.length) return; el.dataset.ready = '1';
try {
const html = await (await fetch(el.dataset.url)).text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const fresh = doc.querySelector('[data-recommendations]');
if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); }
} catch (e) {}
});
}
function initSearch() {
const input = $('[data-predictive-input]');
const results = $('[data-predictive-results]');
if (!input || !results) return;
const initial = results.innerHTML;
let timer, ctrl;
input.addEventListener('input', () => {
clearTimeout(timer);
const q = input.value.trim();
if (q.length < 2) { results.innerHTML = initial; return; }
timer = setTimeout(async () => {
if (ctrl) ctrl.abort();
ctrl = new AbortController();
try {
const url = `${window.theme.routes.search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
const html = await (await fetch(url, { signal: ctrl.signal })).text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const sec = doc.querySelector('.shopify-section') || doc.body;
results.innerHTML = sec.innerHTML;
} catch (e) {}
}, 220);
});
}
function initCollection() {
const sort = $('[data-sort]');
if (sort) sort.addEventListener('change', () => {
const url = new URL(window.location.href);
url.searchParams.set('sort_by', sort.value);
url.searchParams.delete('page');
window.location.href = url.toString();
});
document.addEventListener('click', async (e) => {
const btn = e.target.closest('[data-load-more]');
if (!btn) return;
e.preventDefault();
btn.textContent = 'Carico…';
try {
const html = await (await fetch(btn.href)).text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const grid = $('[data-product-grid]');
const newGrid = doc.querySelector('[data-product-grid]');
if (grid && newGrid) {
const frag = document.createDocumentFragment();
Array.from(newGrid.children).forEach(c => frag.appendChild(c));
grid.appendChild(frag);
initSliders(grid);
}
const newBtn = doc.querySelector('[data-load-more]');
const wrap = btn.closest('.section-cta');
const newWrap = newBtn ? newBtn.closest('.section-cta') : null;
if (wrap) { if (newWrap) wrap.replaceWith(newWrap); else wrap.remove(); }
window.history.replaceState({}, '', btn.href);
} catch (err) { btn.textContent = 'Carica altri'; }
});
}
function openModal(m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked'); }
function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); if (!$('[data-drawer].is-open')) document.body.classList.remove('is-locked'); }
function initWelcome() {
const root = $('[data-welcome]');
if (!root) return;
const modal = $('[data-welcome-modal]', root);
const pill = $('[data-welcome-pill]', root);
const KEY = 'vorm_welcome';
const DAY = 86400000;
const days = parseInt(root.dataset.days, 10) || 14;
let state = {};
try { state = JSON.parse(store.get(KEY) || '{}'); } catch (e) {}
const save = (patch) => { state = Object.assign(state, patch); store.set(KEY, JSON.stringify(state)); };
const subscribed = state.status === 'subscribed';
const recentlyClosed = state.closedAt && (Date.now() - state.closedAt) < days * DAY;
const design = window.Shopify && window.Shopify.designMode;
let opened = false;
const showSuccess = () => {
$('[data-welcome-form]', root).hidden = true;
$('[data-welcome-success]', root).hidden = false;
};
const open = () => { if ($('[data-drawer].is-open')) return; opened = true; openModal(modal); if (pill) pill.classList.add('is-hidden'); };
const close = () => {
closeModal(modal);
if (state.status !== 'subscribed') save({ closedAt: Date.now() });
if (pill && state.status !== 'subscribed' && !state.pillDismissed) pill.classList.remove('is-hidden');
};
if (window.location.hash === '#welcome-form') {
const hasError = $('#welcome-form .errors', root);
if (!hasError) { save({ status: 'subscribed' }); showSuccess(); }
openModal(modal); opened = true;
history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/, ''));
} else if (subscribed) {
} else if (pill && state.closedAt && !state.pillDismissed) {
pill.classList.remove('is-hidden');
}
$$('[data-welcome-close]', root).forEach(b => b.addEventListener('click', close));
const openBtn = $('[data-welcome-open]', root);
if (openBtn) openBtn.addEventListener('click', open);
const dismiss = $('[data-welcome-dismiss]', root);
if (dismiss) dismiss.addEventListener('click', () => { pill.classList.add('is-hidden'); save({ pillDismissed: true }); });
modal.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
if (!design && !subscribed && !recentlyClosed && !opened) {
const delay = parseInt(root.dataset.delay, 10);
if (delay > 0) setTimeout(() => { if (!opened) open(); }, delay * 1000);
if (root.dataset.exit === 'true' && window.matchMedia('(hover: hover)').matches) {
const onLeave = (e) => { if (e.clientY <= 0 && !opened) { open(); document.removeEventListener('mouseout', onLeave); } };
setTimeout(() => document.addEventListener('mouseout', onLeave), 3000);
}
}
const copy = $('[data-copy]', root);
if (copy) copy.addEventListener('click', () => {
if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.copy).then(() => toast('Codice copiato'));
});
document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === root.dataset.sectionId) openModal(modal); });
document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === root.dataset.sectionId) closeModal(modal); });
}
function initReveal() {
if (!('IntersectionObserver' in window)) return;
const targets = $$('.section-title, .coll-card, .card, .story__inner, .faq__item, .review, .reel');
const io = new IntersectionObserver((entries) => {
entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
}, { rootMargin: '0px 0px -8% 0px' });
targets.forEach((t, i) => {
if (t.getBoundingClientRect().top < window.innerHeight) return;
t.classList.add('reveal');
t.style.transitionDelay = ((i % 4) * 60) + 'ms';
io.observe(t);
});
}
function initAll(root) {
initRotators(root); initSliders(root); initReels(root); initProduct(root); initRecommendations(root);
}
document.addEventListener('DOMContentLoaded', () => {
initHeader(); initAll(document); initSearch(); initCollection(); initWelcome();
if (!window.Shopify || !window.Shopify.designMode) initReveal();
});
document.addEventListener('shopify:section:load', (e) => { initAll(e.target); initHeader(); if (e.target.querySelector('[data-welcome]')) initWelcome(); });
window.VORM = { openDrawer, addToCart, formatMoney, toast, initProduct, openQuickView };
})();
